module.exports = __webpack_public_path__ + "static/media/S (31).c9c1bd9b.jpg";